<template> 
  <v-layout row wrap class="contentMonitoring">
    <v-flex xs12 sm6 md3> 
      <wz-list-agents
        :agentSelect.sync="selectedAgent"
        :inMonitoring="true"
        @chatSessionSelected="updateVisSelect"
      ></wz-list-agents>
    </v-flex>
<!--     <v-flex xs12 sm6 md2>
      <wz-list-chats-agent
        v-if="selectAgent"
        :dataAgent="selectedAgent"
        @chatSessionSelected="updateVisSelect"
      >
      </wz-list-chats-agent>
    </v-flex> -->
    <v-flex xs12 sm6 md9 class="contentMonitoringInfosVisiteur">
      <wz-view-chat
        v-if="selectAgent && visSelected"
        :datasViewPupitre="dataVisiteurComputed"
        :placesPupitre="1"
        :selectedAgent="selectedAgent"
        @chatSessionSelect="updateVisSelect"
      ></wz-view-chat>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import _watcheebox from '../watcheebox/watcheebox.js'
export default {
  data () {
    return {
      selectedAgent: {
        'id': '',
        'name': '',
        'status': ''
      },
      oldVisSelected: null,
      visSelected: null
    }
  },

  props: ['dataAgent'],

  methods: {
    // ----------------------------------------------------------------------------
    // change de chat à superviser
    // ----------------------------------------------------------------------------
    updateVisSelect (visiteurID) {
      console.log('updateVisSelect', visiteurID)
      this.oldVisSelected = this.visSelected
      this.visSelected = visiteurID
      // on connect le superviseur au nouveau chat
      _watcheebox.clientConnectRoom({'roomName': 'chat_' + visiteurID})
      // deconnect le superviseur de l'ancien chat si c'est pas le premier chat
      if (this.oldVisSelected !== null && this.oldVisSelected !== visiteurID) {
        _watcheebox.clientQuitRoom({'roomName': 'chat_' + this.oldVisSelected})
      }
    }
  },

  watch: {
    // ----------------------------------------------------------------------
    // Si je change d'agent, je quitte la room en cours
    // ----------------------------------------------------------------------
    selectAgent (data) {
      // console.log('changeAgent', data)
      // deconnect le superviseur de lancien chat si c'est pas le premier chat
      // console.log('this.visSelected', this.visSelected)
      if (this.visSelected !== null) {
        _watcheebox.clientQuitRoom({'roomName': 'chat_' + this.visSelected})
      }
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['listeAllVisiteurs']),

    selectAgent () {
      return this.selectedAgent.id
    },

    dataVisiteurComputed () {
      var visteurDataSelected = _.find(this.listeAllVisiteurs, {'visiteurID': this.visSelected})
      return {'cobrowsing': this.iframeStatus, 'online': true, 'viewStatus': true, 'visiteurDatas': visteurDataSelected, 'visiteurID': this.visSelected}
    }
    // dataVisiteurComputed () {
    //   console.log('this.visSelected', this.visSelected)
    //   var visteurDataSelected
    //   var selectedID
    //   if (this.visSelected) {
    //     selectedID = this.visSelected
    //     visteurDataSelected = _.find(this.listeAllVisiteurs, {'visiteurID': this.visSelected})
    //   } else {
    //     selectedID = this.listeAllVisiteurs[0].visiteurID
    //     visteurDataSelected = this.listeAllVisiteurs[0]
    //   }
    //   return {'cobrowsing': this.iframeStatus, 'online': true, 'viewStatus': true, 'visiteurDatas': visteurDataSelected, 'visiteurID': selectedID}
    // }
  },

  mounted () {
  },

  beforeDestroy () {
    // quite la room avec le visiteur selectionné
    if (this.visSelected !== null) {
      _watcheebox.clientQuitRoom({'roomName': 'chat_' + this.visSelected})
    }
  }
}
</script>

<style>
.contentMonitoring {height: calc(100vh - 106px) !important;}
.contentMonitoringInfosVisiteur {height: 100%;}
</style>



// WEBPACK FOOTER //
// src/components/trafic/Monitoring.vue